<template>
    <v-container
        fluid
    >
        <v-row
            align="center"
            justify="center"
        >
            <img
                class="elevation-1 rounded-circle"
                height="128"
                width="128"
                src="/logologin.jpeg"
            >
        </v-row>
        <v-row
        no-gutters
            align="center"
            justify="center"
        >
            <v-col
                cols="12"
                sm="8"
                md="4"
            >
                <v-card
                    class="mx-auto my-12"
                    max-width="400"
                >
                    <v-card-title>
                        Recuperar contraseña
                    </v-card-title>
                    <v-card-text>
                        <v-form
                            ref="form"
                            v-model="valid"
                            lazy-validation
                        >
                            <v-text-field
                                id="password"
                                label="Nueva contraseña"
                                name="password"
                                v-model="password"
                                :rules="passRules"
                                :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                                :type="show1 ? 'text' : 'password'"
                                @click:append="show1 = !show1"
                                outlined
                                dense
                                required
                            ></v-text-field>

                            <v-text-field
                                id="password"
                                label="Confirmacion nueva contraseña"
                                name="password"
                                v-model="confirmPassword"
                                :rules="confirmPasswordRules"
                                :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                                :type="show1 ? 'text' : 'password'"
                                @click:append="show1 = !show1"
                                outlined
                                dense
                                required
                            ></v-text-field>
                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn
                            v-if="!successRecover"
                            width="95%"
                            color="success"
                            class="ma-2"
                            :disabled="!valid"
                            @click="validate"
                        >
                            Cambiar
                        </v-btn>
                        <v-btn
                            v-else
                            width="95%"
                            color="success"
                            class="ma-2"
                            :disabled="!valid"
                            to="/login"
                        >
                            Ir a Login
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>
        <v-row
            align="end"
            justify="center"
        >
            <p class="font-weight-light">
                Copyright © {{currentYear}} — SoundAnalytics 
            </p>
        </v-row>
    </v-container>
</template>

<script>
	import moment from 'moment'

	export default {
		name: 'Login',

		data: () => ({
            valid: false,
            show1: true,
            passRules: [
                v => !!v || 'Password es requerido',
            ],
            password: '',
            confirmPassword: ''
		}),
		
		methods: {
            validate () {
                const isValid = this.$refs.form.validate()

                if (!isValid)
                    return
                
                const payload = {
                    password: this.password,
                    token: this.token
                }
                
                this.$store.dispatch('recover', payload)
            },
		},

		computed: {
            token () {
                return this.$route.query.token
            },
            errorRecover () {
                return this.$store.getters.errorRecover
            },
            successRecover () {
                return this.$store.getters.successRecover
            },
            currentYear () {
                return moment().format("YYYY")
            },
            confirmPasswordRules() {
                return [
                    v => !!v || 'Confirmar password',
                    v => v === this.password || 'Password no coinciden',
                ]
            },
		},

		watch : {
            loggedIn (val) {
                if (val)
                    this.$router.push('/')
            }
		},

		created () {
			moment.locale('es-us')
		}

	}
</script>